import styled, { css } from "styled-components";

const columnLayout = columnCount => {
	var i;
	var columnLayoutToReturn = "";
	for (i = 0; i < columnCount; i++) {
		columnLayoutToReturn += "1fr ";
	}
	return columnLayoutToReturn;
};

const setGridLayoutIfNeeded = props => {
	if (props.$columnCount) {
		return css`
			display: grid;
			grid-template-columns: ${columnLayout(props.$columnCount)};
			max-width: 1200px;
			width: 80%;
			justify-content: space-around;
			margin: 0px auto;
			grid-column-gap: 30px;

			@media only screen and (max-width: 720px) {
				grid-template-columns: ${columnLayout(1)};
				width: unset;
				margin: 0px 5px;
			}
		`;
	}
};

export const SuggestedVideosContainer = styled.div`
	display: flex;
	justify-content: start;
	flex-direction: column;
	width: 350px;
	max-width: 30%;
	left: 0px;
	padding-right: 5px;
	margin: 0px 10px;

	@media only screen and (max-width: 720px) {
		display: grid;
		max-width: 1200px;
		justify-content: space-around;
		grid-column-gap: 30px;
		grid-template-columns: ${columnLayout(1)};
		width: unset;
		margin: 0px 5px;
	}

	${setGridLayoutIfNeeded};
`;

export const Text = styled.p`
	text-align: center;
	color: lightgray;
`;
